import { render, staticRenderFns } from "./IndexSearchResults.vue?vue&type=template&id=61c36b4e&scoped=true&"
import script from "./IndexSearchResults.vue?vue&type=script&lang=js&"
export * from "./IndexSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearchResults.vue?vue&type=style&index=0&id=61c36b4e&prod&lang=scss&"
import style1 from "./IndexSearchResults.vue?vue&type=style&index=1&id=61c36b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c36b4e",
  null
  
)

export default component.exports